import Controller, { OnBeforeSubmit, OnCancel } from '@philips-internal/oswald-ui-core/lib/client';
import { FormAPI, ModalService, TextAreaAPI, ToastService } from '@philips-internal/oswald-ui-components';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { Value } from '@philips-internal/oswald-ui-core';

import { Inject } from '@odinjs/odin';

import { WoundsDressingsInactivateAliases as Alias, FragmentNames } from '../../../codegen';
import BaseController from '../../BaseController';
import { DialogType, ModalType, SimpleDialogParams } from '../../../interfaces/simple-dialog';
import { SimpleDialog } from '../../dialog-helper';
import { Endpoint } from '../../../constants/endpoints';
import { WoundsDressingsTabListContext } from '../service/wounds-dressing-tab-list-service';
import { WoundsDressingTabType } from '../types/wounds-dressings-types';
@Controller({ fragment: FragmentNames.WOUNDS_DRESSINGS_INACTIVATE })
export default class WoundsDressingsInactivateController extends BaseController {

  @Inject(Alias.FORM_WOUNDS_DRESSINGS_INACTIVATE)
  private formAPI!: FormAPI;

  @Inject(Alias.TEXT_AREA_JUSTIFY)
  private textAreaAPI!: TextAreaAPI;
  private inactivateWoundsDressings(endpoint: string): void {
    const { woundId } = this.historyService.getCurrentRouteParams();
    const justification = this.textAreaAPI.getValue();

    this.formAPI.setLoading(true);

    const body = {
      justification,
      woundsDressingsId: woundId,
    } as Record<string, Value>;

    HttpService.put(endpoint, undefined, {body})
      .then(() => {
        this.historyService.back();
        this.showMessageDialog('title.disable-record', 'patient-evolution.successfully-inactivated-message');
      }).catch((err) => {
        err?.body && this.showToast(err?.body, ToastLevel.ERROR);
      }).finally(() => {
        this.formAPI.setLoading(false);
      })
  }

  private showToast(message: string, level: ToastLevel): void {
    ToastService.open({
      dismissible: true,
      highlight: false,
      id: 'wounds-dressings-inactivate',
      level,
      message,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    })
  }

  private showMessageDialog(title: string, description: string): void {
    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: description,
      dialogType: DialogType.ALERT,
      modalType: ModalType.DIALOG,
      onClickOk: (): void => ModalService.close(FragmentNames.WOUNDS_DRESSINGS_INACTIVATE),
      titleDialog: title,
      titleOnOk: 'OK',
    }
    SimpleDialog.openDialog(dialogParams);
  }

  @OnCancel({ target: Alias.FORM_WOUNDS_DRESSINGS_INACTIVATE })
  handleCancelForm(): void {
    ModalService.close(FragmentNames.WOUNDS_DRESSINGS_INACTIVATE);
  }

  @OnBeforeSubmit({ target: Alias.FORM_WOUNDS_DRESSINGS_INACTIVATE })
  handleBeforeSubmit(): void {
    const tab = WoundsDressingsTabListContext.currentTab;
    if (tab === WoundsDressingTabType.WOUNDS) {
      this.inactivateWoundsDressings(Endpoint.INACTIVATE_WOUND);
      return;
    }
  }
}